import i18n from '~/lib/i18n'

import { HomePage } from '~/__generated_types__/globalTypes'

export const PAGES = [
  {
    value: HomePage.Loadboard,
    label: i18n.t('homePage.loadBoard', { ns: 'settings' }),
  },
  {
    value: HomePage.DriverVisibility,
    label: i18n.t('homePage.driverVisibility', { ns: 'settings' }),
  },
]

export const SUCCESS_DELAY = 5000
export const ERROR_DELAY = 15000
